import { Input } from '@mui/joy';
import SearchIcon from '@mui/icons-material/Search';

let sm = {
  fontSize: '12.5px',
  paddingInline: '13px',
  paddingBlock: '8px',
  lineHeight: '12.5px',
};

export function SearchBar({ value, onChange, entity, size = 'md', sx }) {
  return (
    <Input
      sx={{        
        flex: 1,
        borderRadius: '999px',
        border: 'none',
        backgroundColor: '#fff',
        boxShadow: `var(--joy-shadow-${size})`,
        paddingInline: '16px',
        paddingBlock: '10px',
        fontSize: '13.5px',
        fontWeight: 500,
        minHeight: 0,
        lineHeight: '20px',
        color: 'neutral.900',
        '& input::placeholder': { color: 'var(--joy-palette-neutral-600)', opacity: 1 },
        '&:focus-within': { boxShadow: 'var(--joy-shadow-sm)' },
        ...(size === 'sm' && sm),
        ...sx,
      }}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={`Search ${entity}`}
      startDecorator={<SearchIcon sx={{ color: 'neutral.600', fontSize: '20px' }} />}
    />
  );
}